<script lang="ts">
  import authapi from "@/functions/api/authapi";
  import authservice from "@/functions/services/authservice";
  import { isauth } from "@/store";
  import Cookies from "js-cookie";

  const ev로그인클릭 = async () => {
    const password = prompt("비밀번호");
    const result = await authapi.signin(password);
    if (result) {
      authservice.makeauth();
      location.reload();
    } else alert("비밀번호 틀림");
  };

  const ev로그아웃클릭 = () => {
    authservice.removeauth();
    location.reload();
  };
  let isauth = Cookies.get("auth");
</script>

{#if isauth == "true"}
  <button on:click={ev로그아웃클릭}>관리자 로그아웃</button>
{:else}
  <button on:click={ev로그인클릭}>관리자 로그인</button>
{/if}

<style>
  button {
    background: none;
    border: none;
    color: #f5deb3;
  }
</style>
